import { injectable } from 'inversify'

/**
 * Declarative half of the page title — the same split as RoutesConfig /
 * NavigationConfig: this owns *how a title is composed*, the Presenter owns
 * *when it is applied*.
 *
 * `appName` is a brand, so it is deliberately not a translation key: a product
 * name is the same word in every locale, the same reasoning that keeps locale
 * endonyms out of TranslationsConfig (§U).
 */
@injectable()
export class PageTitleConfig {
  readonly appName = 'Board Game Arena'

  /** Shown when a route declares no titleKey of its own. */
  readonly fallbackTitleKey = 'app.untitledPage'

  compose(pageTitle: string): string {
    return `${pageTitle} · ${this.appName}`
  }
}
